import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { TenantVegetationType } from '../../types/tenantVegetationType';

interface Props {
  rows: TenantVegetationType[];
  isLoading: boolean;
  onEdit: (row: TenantVegetationType) => void;
  onDelete: (id: number) => void;
}

export default function VegetationTypeTable({ rows, isLoading, onEdit, onDelete }: Props) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: 'rgba(0,0,0,0.04)' }}>
            <TableCell><strong>Vegetation Class</strong></TableCell>
            <TableCell align="right"><strong>Max Fuel Load</strong></TableCell>
            <TableCell align="right"><strong>Accumulation Rate</strong></TableCell>
            <TableCell><strong>Model Class</strong></TableCell>
            <TableCell align="center"><strong>Actions</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell>{row.veg_class}</TableCell>
              <TableCell align="right">{row.max_fuel_load}</TableCell>
              <TableCell align="right">{row.accumulation_rate}</TableCell>
              <TableCell>{row.model_class_name ?? row.model_class ?? '—'}</TableCell>
              <TableCell align="center">
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={() => onEdit(row)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton size="small" color="error" onClick={() => onDelete(row.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
